import {DETAILS_VIEW_TYPE} from 'utils/constants';
import AsyncTaskActionExecutor from 'components/mytasks/AsyncTaskActionExecutor.component';
import AsyncTaskActionExecutorDocument from 'components/documentoverview/AsyncTaskActionExecutor.component';
import AsyncTaskActionExecutorProcess from 'components/processoverview/AsyncTaskActionExecutor.component';
import AsyncTaskActionExecutorHistory from 'components/myhistory/AsyncTaskActionExecutor.component';
import type {AsyncTaskActionExecutorProps} from 'types/asyncTaskActionExecutor';

/**
 * this is used in TaskDetails
 * routes to the proper AsyncTaskActionExecutor for each Details View Type
 */
export const AsyncTaskActionExecutorTask = (props: AsyncTaskActionExecutorProps) => {
    switch (props.type) {
        case DETAILS_VIEW_TYPE.DOCUMENT:
            return <AsyncTaskActionExecutorDocument {...props}/>;
        case DETAILS_VIEW_TYPE.HISTORY_TASK:
            return <AsyncTaskActionExecutorHistory {...props}/>;
        case DETAILS_VIEW_TYPE.PROCESS:
            return <AsyncTaskActionExecutorProcess {...props}/>;
        default:
            return <AsyncTaskActionExecutor {...props}/>;
    }
};

export default AsyncTaskActionExecutorTask;
